import { Translation } from "@/types";

import axios from "axios";
import { Store } from "vuex";

import Cookies from "js-cookie";

export const translate = (locale: string, arr: Array<Translation>) => {
	const trans = arr.filter(t => t.lang == locale).shift();

	if (!trans) {
		return "error";
	}

	return trans.text;
};

export const parseJwt = (token: string) => {
	const base64Url = token.split(".")[1];
	const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
	const jsonPayload = decodeURIComponent(
		atob(base64)
			.split("")
			.map(function(c) {
				return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
			})
			.join("")
	);
	return JSON.parse(jsonPayload);
};

export const clearAuth = (store: Store<any>) => {
	Cookies.remove("jwt");
	if (axios.defaults.headers.jwt) {
		delete axios.defaults.headers.jwt;
	}
	store.commit("setAuth", { jwt: null, authObject: null });
	store.commit("setOrgLang", { org: null, lang: null });
	store.commit("setAvailableServices", { orgServices: null });
};

export const verifyAuth = async (store: Store<any>, jwt: string) => {
	if (jwt) {
		const userData = parseJwt(jwt);
		if (userData && userData.user) {
			try {
				await axios.get("auth/testauth", { headers: { authorization: "Bearer " + Cookies.get("jwt") } });
				axios.defaults.headers.authorization = "Bearer " + jwt;
				store.commit("setAuth", { authObject: JSON.parse(userData.user), jwt: jwt });
				store.commit("setOrgLang", { org: localStorage.getItem("org"), lang: localStorage.getItem("lang") });
				store.commit("setAvailableServices", { orgServices: localStorage.getItem("orgServices")?.split(",") })
				Cookies.set("jwt", jwt, { expires: 1 });
				return true;
			} catch (error) {
				clearAuth(store);
				return false;
			}
		}
		return false;
	}

	return false;
};
